import { getIconUnicode } from "@baishuyun/ai-feat-utils";

function getFormIconClass(icon: number): string {
  const isNew = icon >= 25;
  const newStr = isNew ? '-new' : '';
  return `node-icon icon-bsy-form${newStr} icon${newStr}-bsy-form-${icon}`;
}

export const AppIcon = ({
  name
}: {
  name: number | string;
}) => {
  return (
    <div className={"imgbg-bsy-app imgbg-bsy-app-" + name}/>
  );
}

export const FontIcon = ({
  code,
  name,
  className,
  style,
  color,
}: {
  code?: string;
  name?: number;
  className?: string;
  style?: React.CSSProperties;
  color?: string;
}) => {
  if (!code && !name) {
    return null;
  }

  if (code) {
    return (
      <i
        className={`sdk-icon ${className || ''}`}
        style={{ ...style, color }}
        dangerouslySetInnerHTML={{ __html: code }}
      />
    );
  }

  const iconCode = code || getIconUnicode(name?.toString() || '');
  if (!iconCode) {
    return (
      <i
        className={getFormIconClass(name!)}
        style={{ fontSize: 16, lineHeight: 1 }}
      />
    )
  }

  return (
    <i
      className={`sdk-icon ${className || ''}`}
      style={{ ...style, color }}
      dangerouslySetInnerHTML={{ __html: iconCode }}
    />
  );
};
